import { Email } from "./screens/Email";
import { Password } from "./screens/Password";
import { OneshotContract } from "./screens/OneshotContract";
// import { OneshotConfirmation } from "./screens/OneshotConfirmation";
import { OneshotConfirmationPhone } from "./screens/UpdatePhone";
import { Bussines } from "./screens/Bussines";
import { CountrySelector } from "./screens/CountrySelector";
import { CurrencySelector } from "./screens/CurrencySelector";
import { PaymentSelector } from "./screens/PaymenSelector";
import { BankSelector } from "./screens/BankSelector";
import { CryptoSelector } from "./screens/CryptoSelector";
import { CryptoPayment } from "./screens/CryptoPayment";
import { FiatPayment } from "./screens/FiatPayment";

import { useDispatch, useSelector, } from 'react-redux'
import { setRouterLength, setRoutes } from "../../../main/slices/routerSlice";
import { useState, useEffect } from "react";
// import { useCookies } from "react-cookie";
import { Kyc } from "./screens/Kyc";
import { Success } from "./screens/Success";

export const ScreenRouter = () => {

    // GET THE CURRENT SCREEN (THE screen const CHANGES WHEN THE state.router.value IS UPDATED ON THE routerSlice)
    const screen = useSelector(({ router }) => router);
    const dispatch = useDispatch();
    // const [cookies] = useCookies(["token", "u"]);
    const store = (new URLSearchParams(window.location.search)).get("Store") ? (new URLSearchParams(window.location.search)).get("Store") : false;

    // MAP THE COMPONENTS INTO THE ROUTER
    const [routes] = useState([
        {   // 0
            next: 1, last: 0,
            component: (path) => <Email />
        },
        {   // 1
            next: 2, last: 0,
            component: (path) => <Password />
        },
        {   // 2
            next: 3, last: 1,
            component: (path) => <Kyc />
        },
        {   // 3
            next: 4, last: 2,
            component: (path) => <OneshotContract />
        },
        {   // 4
            next: 5, last: 3,
            paths: ["phone", "otp"], defaultPath: "phone",
            component: (path) => <OneshotConfirmationPhone path={path} />, //OneshotConfirmation Temporaly change
        },
        {   // 5
            next: 6, last: 4,
            component: (path) => <Bussines />
        },
        {   // 6
            next: !store ? 7 : 8, last: 5,
            component: (path) => <CountrySelector />
        },
        {   // 7
            next: 8, last: 6,
            component: (path) => <CurrencySelector />
        },
        {   // 8
            next: null, last: !store ? 7 : 6,
            component: (path) => <PaymentSelector />
        },
        {   // 9
            next: 10, last: 8,
            component: (path) => <BankSelector />
        },
        {   // 10
            next: 13, last: 9,
            paths: ["account-details", "account"], defaultPath: "account",
            component: (path) => <FiatPayment path={path} />,
        },
        {   // 11
            next: 12, last: 8,
            component: (path) => <CryptoSelector />
        },
        {   // 12
            next: 13, last: 11,
            paths: ["network", "wallet"], defaultPath: "network",
            component: (path) => <CryptoPayment path={path} />,
        },
        {   // 13
            next: 13, last: 13,
            component: (path) => <Success path={path} />,
        }
    ]);

    // SET THE ROUTES AND ROUTES LENGTH JUST ONCE
    useEffect(() => {
        dispatch(setRouterLength({ length: routes.length }));
        dispatch(setRoutes(
            routes.map(r => ({ next: r.next, last: r.last }))
        ));
    }, [routes, dispatch]);


    // RETURN THE SELECTED SCREEN BY FETCHING THE INDEX (screen) INTO THE STORE
    // IF A PATH IS PROVIDED AND EXISTS IT WILL BE SENT INTO THE SCREEN, OTHERWISE THE DEFUALT OR NULL WILL BE SENT
    const path = routes[screen.current]?.paths?.includes(screen.path) ? screen.path : routes[screen.current]?.defaultPath
    return routes[screen.current].component(path);
}